export default "__VITE_ASSET__Dhssv_oP__"